module.exports = __webpack_public_path__ + "static/media/deer.fbd621a6.svg";